// utils/embedUtils.js
export const getEmbedUrl = (url) => {
  if (!url) return "";

  // ✅ Google Drive
  if (url.includes("drive.google.com")) {
    const match = url.match(/\/d\/([^/]+)\//);
    const fileId = match ? match[1] : null;
    if (!fileId) return url;

    if (url.includes("presentation")) {
      return `https://docs.google.com/presentation/d/${fileId}/embed`;
    }
    if (url.includes("document")) {
      return `https://docs.google.com/document/d/${fileId}/preview`;
    }
    if (url.includes("spreadsheets")) {
      return `https://docs.google.com/spreadsheets/d/${fileId}/preview`;
    }
    return `https://drive.google.com/file/d/${fileId}/preview`;
  }

  // ✅ Dropbox
  if (url.includes("dropbox.com")) {
    return url.replace("?dl=0", "?raw=1");
  }

  // ✅ OneDrive
  if (url.includes("onedrive.live.com")) {
    return url.replace("redir?", "embed?");
  }

  // ✅ Box.com
  if (url.includes("box.com")) {
    return url.replace("/file/", "/embed/preview/");
  }

  // ✅ iCloud Drive (langsung pakai)
  if (url.includes("icloud.com")) {
    return url;
  }

  // ✅ YouTube
  if (url.includes("youtube.com/watch?v=")) {
    const videoId = url.split("v=")[1].split("&")[0];
    return `https://www.youtube.com/embed/${videoId}`;
  }
  if (url.includes("youtu.be/")) {
    const videoId = url.split("youtu.be/")[1].split("?")[0];
    return `https://www.youtube.com/embed/${videoId}`;
  }

  // ✅ Cloudinary / Firebase langsung pakai
  if (
    url.includes("res.cloudinary.com") ||
    url.includes("firebasestorage.googleapis.com")
  ) {
    return url;
  }

  // ✅ Default: balikin langsung
  return url;
};
